import { Component, OnInit } from '@angular/core';
import { GlobalserviceService } from '../globalservice.service';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})
export class SettingComponent implements OnInit {
  time: boolean;
  distance: boolean;
  seetingvalue: any;
  message: any;
  distime: any; autotime: number;
  autodis: number;
  ti: any;
  tis: any;
  distances: any;
  times: any;
  selecttime; selectdistance;
  lastdistance; lasttime;
  constructor(public globalservice: GlobalserviceService, public snackBar: MatSnackBar, ) { }

  ngOnInit() {
    this.select_distance_time();
    this.AutoCheckoutDistance();
    this.AutoCheckoutTime();
  }

  toggle() {
    this.select_distance_time();
    this.time = true;
    this.distance = false;
  }

  toggle1() {
    this.select_distance_time();
    this.time = false;
    this.distance = true;
  }

  AutoCheckoutDistance() {
    this.globalservice.enableloader();
    this.globalservice.autocheckout_distance().subscribe(responsedata => {
      this.globalservice.disableloader();
      if (responsedata.Success) {
        this.lastdistance = responsedata.Data;
      }
    },
      err => {
        this.globalservice.disableloader();
        alert('Network Error');
      });
  }

  AutoCheckoutTime() {
    this.globalservice.enableloader();
    this.globalservice.autocheckout_time().subscribe(responsedata => {
      this.globalservice.disableloader();
      if (responsedata.Success) {
        this.lasttime = responsedata.Data;
      }
    },
      err => {
        this.globalservice.disableloader();
        alert('Network Error');
      });
  }


  seeting(mydata) {
    console.log(mydata); debugger;
    if (mydata == undefined) {
      this.snackBar.open('Please select Time', '', { duration: 3000 });
    } else {
      var data = {
        "checkout_hours": mydata
      };
      this.globalservice.enableloader();
      this.globalservice.UpdateSettings(data).subscribe(responsedata => {
        this.globalservice.disableloader();
        if (responsedata.Success) {
          this.seetingvalue = responsedata['Data'];
          this.message = responsedata['Message']
          this.snackBar.open(this.message, '', { duration: 3000 });
        } else {
          this.snackBar.open('Incorrect Credentials', '', { duration: 3000 });
        }
      },
        err => {
          this.globalservice.disableloader();
          alert("Network Error");
        });
    }
  }
  seetings(mydata) {
    if (mydata == undefined) {
      this.snackBar.open('Please select Distance (KM)', '', { duration: 3000 });
    } else {
      var data = {
        "checkout_Km": mydata,

      };
      this.globalservice.enableloader();
      this.globalservice.UpdateSettings(data).subscribe(responsedata => {
        this.globalservice.disableloader();
        if (responsedata.Success) {
          console.log(responsedata);  debugger;
          this.seetingvalue = responsedata['Data'];
          this.message = responsedata['Message']
          this.snackBar.open(this.message, '', { duration: 3000 });
        } else {
          this.snackBar.open('Incorrect Credentials', '', { duration: 3000 });
        }
      },
        err => {
          this.globalservice.disableloader();
          alert("Network Error");
        });
    }
  }



  select_distance_time() {
    this.globalservice.enableloader();debugger;
    this.globalservice.select_time_dis().subscribe(responsedata => {
      this.globalservice.disableloader();
      if (responsedata.Success) {
        console.log(responsedata);debugger;
        this.distime = responsedata['Data'][0];
        // console.log(this.distime);
        this.distances = this.distime['AutoCheckOutDistance'];
         console.log(this.distances);
        this.times = this.distime['AutoCheckOutTime'];
         console.log(this.times);debugger;

         this.selecttime = this.times;
         this.selectdistance =  this.distances;
      }
    },
      err => {
        this.globalservice.disableloader();
        alert("Network Error");
      });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }



}
